const reducer = (promise, fn) => promise.then(result =>
  fn().then(fnResult => [...result, fnResult]));
export default promises => promises.reduce(reducer, Promise.resolve([]));
